import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { EssenceBalance } from '@sorare/core/src/components/balance/EssenceBalance';
import { GemsBalance } from '@sorare/core/src/components/commonGame/GemsBalance';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSeriesNav } from '@sorare/core/src/hooks/commonGame/useSeriesNav';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { getCommonCardShardsCount } from '@sorare/core/src/lib/currentUser';

export const SeriesBalance = () => {
  const {
    flags: { useEnableSeriesMarket = false },
  } = useFeatureFlags();

  const { currentUser } = useCurrentUserContext();
  const isSimplifiedNav = useSeriesNav();
  return (
    <Horizontal>
      {!!useEnableSeriesMarket && (
        <EssenceBalance
          value={getCommonCardShardsCount(currentUser, 'winter') || 0}
          rarity={Rarity.common}
          cardSetSlug="winter"
        />
      )}
      {(!isSimplifiedNav || !useEnableSeriesMarket) && (
        <EssenceBalance
          value={getCommonCardShardsCount(currentUser, 'common-base-set') || 0}
          rarity={Rarity.common}
          cardSetSlug="common-base-set"
        />
      )}
      <GemsBalance balance={currentUser?.gemsBalances[0]?.amount || 0} />
    </Horizontal>
  );
};
